import { backendPublicPath } from "@/api/servicePaths";

import FETCHRAW from "../fetchRaw";

export const getDashboardData = ({ params, serverSideReq }: { params?: any; serverSideReq?: any }) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/dashboard/"),
    method: "GET",
    // NOTE: Timezone filter has error from backend, so not including it for now
    // TODO: Re-enable timezone once backend issue is fixed
    // params: { ...params, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    params: { ...params },
    serverSideReq
  });

export const getAccessibleGroups = () => getAccessibleGroupsCached();

let accessibleGroupsPromise: Promise<any> | null = null;
let accessibleGroupsFetchedAtMs = 0;
const ACCESSIBLE_GROUPS_TTL_MS = 30_000;

export const getAccessibleGroupsCached = (opts?: {
  force?: boolean;
  signal?: AbortSignal;
  suppressAuthLogoutOn401?: boolean;
}) => {
  const force = Boolean(opts?.force);
  const now = Date.now();
  const isFresh = now - accessibleGroupsFetchedAtMs < ACCESSIBLE_GROUPS_TTL_MS;

  if (!force && accessibleGroupsPromise && isFresh) {
    return accessibleGroupsPromise;
  }

  accessibleGroupsPromise = FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/dashboard/accessible-groups/`),
    method: "get",
    signal: opts?.signal,
    suppressAuthLogoutOn401: opts?.suppressAuthLogoutOn401
  }).then(
    (res) => {
      accessibleGroupsFetchedAtMs = Date.now();
      return res;
    },
    (err) => {
      accessibleGroupsPromise = null;
      accessibleGroupsFetchedAtMs = 0;
      throw err;
    }
  );

  return accessibleGroupsPromise;
};

export const getAccessibleUsers = ({
  params
}: {
  params?: {
    limit?: number;
    filter?: { name: string };
    offset?: number;
    order_by?: string;
  };
}) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/dashboard/accessible-users/`),
    method: "GET",
    params: params
  });
